/**
 * Service: householdApi
 */
angular.module('acme.common.service.householdApi', [])
.service('HouseholdApiService', ['$http', function($http) {
    return {

        service: '',

        init: function(endpoint) {
            this.service = endpoint + '/household';
            return this;
        },
    

        detail: function(householdId) {
            return $http({
                method: 'get',
                url: this.service.replace(/v1/, 'v2') + '/' + householdId
            });
        }
    };
}]);